module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 7
// module chunks = 0